
import { Navigate } from 'react-router-dom'
import { useUser } from '@/hooks/useUser'

interface ProtectedRouteProps {
  children: React.ReactNode
}

/**
 * ProtectedRoute 컴포넌트
 * 인증이 필요한 페이지를 보호하는 컴포넌트
 * 인증되지 않은 사용자는 UserManagement 페이지로 리다이렉트
 * 초기 화면은 최소 1.5초 유지 후 전환
 */
function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, loading } = useUser()

  if (loading) {
    return null
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}


export default ProtectedRoute

